import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { ProgramConfig, ProgramLpa } from '@tdf/rtpca-models';
import { programConfigApiActions } from './actions';

export interface State {
  programConfigs: ProgramConfig[];
  lpaPrograms: any[];
  loading: boolean;
  error: string;
  isUpdate: boolean;
  id: number;
}

export const initialState: State = {
  programConfigs: [],
  lpaPrograms: [],
  loading: false,
  error: '',
   isUpdate: false,
  id: 0,
};

export const programConfigFeature = createFeature({
  name: 'programConfig',
  reducer: createReducer(
    initialState,
    on(programConfigApiActions.loadProgramConfig, (state) => ({
      ...state,
      loading: true,
    })),
    on(
      programConfigApiActions.loadProgramConfigSuccess,
      (state, { programConfigs }) => ({
        ...state,
        programConfigs,
        loading: false,
      })
    ),
    on(programConfigApiActions.loadProgramConfigFailure, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to load program configs',
    })),
    on(programConfigApiActions.saveProgramConfig, (state) => ({
      ...state,
      loading: true,
    })),
    on(
      programConfigApiActions.saveProgramConfigSuccess,
      (state, { programConfig }) => ({
        ...state,
        programConfigs: [...state.programConfigs, programConfig],
        loading: false,
      })
    ),
    on(programConfigApiActions.deleteProgramConfig, (state) => ({
      ...state,
      loading: true,
    })),
    on(programConfigApiActions.deleteProgramConfigSuccess, (state) => ({
      ...state,
      loading: false,
    })),
    on(programConfigApiActions.loadAvailableLPAPrograms, (state) => ({
      ...state,
      loading: true,
    })),
    on(
      programConfigApiActions.loadAvailableLPAProgramsSuccess,
      (state, { lpaPrograms }) => ({
        ...state,
        lpaPrograms,
        loading: false,
      })
    ),
    on(programConfigApiActions.updateProgramSuccess, (state) => ({
      ...state,
      id: 0,
      isUpdate: false,
      loading: false,
    })),
    on(programConfigApiActions.setUpdate, (state, { isUpdate, id }) => ({
      ...state,
      isUpdate,
      id,
    })),
  ),
});

export const {
  selectLoading,
  selectProgramConfigs,
  selectLpaPrograms,
  selectProgramConfigState,
  selectIsUpdate,
  selectId
} = programConfigFeature;

export const selectGroupedLPAProgram = createSelector(
  selectProgramConfigState,
  (state): ProgramLpa[] => {
    return [...state.lpaPrograms].sort((a, b) => {
      const dateA = a.uploadDate ? new Date(a.uploadDate).getTime() : 0;
      const dateB = b.uploadDate ? new Date(b.uploadDate).getTime() : 0;
      return dateB - dateA;
    });
  }
);

export const selectProgramToEdit = createSelector(
  selectProgramConfigs,
  selectId,
  (programConfigs, id) => {
    return programConfigs.find((programConfig) => programConfig.id === id);
  }
);
